import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import axiosAdminBlob from "../../../shared/utils/axiosAdminBlob";
import { EcoSystemLicenseStats } from "../../../types/adminConfig";
import {
  CountRespondDto,
  DiskspaceRespondDto,
  LicenseChartRequestDto,
  LicenseChartRespondDto,
  TopDocWorkgroupDto,
  TopMemberWorkgroupDto,
} from "../../../types/adminHome";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminHomeApi {
  getdiskSpace(): Promise<DiskspaceRespondDto>;
  getCreatedWorkgroupCount(): Promise<CountRespondDto>;
  getSharedDocCount(): Promise<CountRespondDto>;
  getLicenseInfo(): Promise<EcoSystemLicenseStats>;
  getMemberCnt(): Promise<CountRespondDto>;
  getLineChart(data: LicenseChartRequestDto): Promise<LicenseChartRespondDto>;
  getTopMemberWorkgroup(): Promise<TopMemberWorkgroupDto[]>;
  getTopDoc(): Promise<TopDocWorkgroupDto[]>;
  downloadChart(data: LicenseChartRequestDto): Promise<any>;
}

class AdminHomeServerApi implements AdminHomeApi {
  async getdiskSpace(): Promise<DiskspaceRespondDto> {
    const resp = await axiosAdmin.get<DiskspaceRespondDto>(
      `${GATEWAY_URL}/wapi/admins/dashboard/diskspace`
    );

    return Promise.resolve(resp.data);
  }

  async getCreatedWorkgroupCount(): Promise<CountRespondDto> {
    const resp = await axiosAdmin.get<CountRespondDto>(
      `${GATEWAY_URL}/wapi/admins/dashboard/workgroup`
    );

    return Promise.resolve(resp.data);
  }

  async getSharedDocCount(): Promise<CountRespondDto> {
    const resp = await axiosAdmin.get<CountRespondDto>(
      `${GATEWAY_URL}/wapi/admins/dashboard/share/doc`
    );

    return Promise.resolve(resp.data);
  }

  async getLicenseInfo(): Promise<EcoSystemLicenseStats> {
    const resp = await axiosAdmin.get<EcoSystemLicenseStats>(
      `${GATEWAY_URL}/wapi/admins/dashboard/license`
    );

    return Promise.resolve(resp.data);
  }

  async getMemberCnt(): Promise<CountRespondDto> {
    const resp = await axiosAdmin.get<CountRespondDto>(
      `${GATEWAY_URL}/wapi/admins/dashboard/member`
    );
    return Promise.resolve(resp.data);
  }

  async getLineChart(
    data: LicenseChartRequestDto
  ): Promise<LicenseChartRespondDto> {
    const resp = await axiosAdmin.post<LicenseChartRespondDto>(
      `${GATEWAY_URL}/wapi/admins/dashboard/linechart`,
      data
    );

    return Promise.resolve(resp.data);
  }

  async getTopMemberWorkgroup(): Promise<TopMemberWorkgroupDto[]> {
    const resp = await axiosAdmin.get<TopMemberWorkgroupDto[]>(
      `${GATEWAY_URL}/wapi/admins/dashboard/top/workgroup`
    );

    return Promise.resolve(resp.data);
  }

  async getTopDoc(): Promise<TopDocWorkgroupDto[]> {
    const resp = await axiosAdmin.get<TopDocWorkgroupDto[]>(
      `${GATEWAY_URL}/wapi/admins/dashboard/top/doc`
    );

    return Promise.resolve(resp.data);
  }

  async downloadChart(data: LicenseChartRequestDto): Promise<any> {
    try {
      const resp = await axiosAdminBlob.post<any>(
        `${GATEWAY_URL}/wapi/admins/dashboard/chart/excel`,
        data
      );

      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
}

const adminHomeApi: AdminHomeApi = new AdminHomeServerApi();
export default adminHomeApi;
